import React, { Fragment, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled, css } from "twin.macro";
import { Image, Modal, Popconfirm, Tooltip } from "antd";
import {
	EmptyData,
	Invite,
	Loading,
	PageLoading,
	SplitPane,
} from "../../components";
import Auth from "../../lib/middleware/auth";
import { useMutation } from "react-query";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import wife from "../../assets/images/bride.webp";
import hus from "../../assets/images/groom.jpeg";
import { AlertOutlined, ScheduleOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { floatBtn, hideScrollbar } from "../../lib/styles/styleLibrary";
import {
	deleteWeddingInvite,
	sendWeddingInvite,
} from "../../redux/actions/wedding";
import errorHandler from "../../redux/actions/errorHandler";
import { useGuestList } from "../../redux/api/Registry";

const Wrapper = styled.div`
	.hide-scrollbar {
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}
	}
`;

const active = (props) => css`
	${tw`text-appPink! bg-white text-xs md:text-base font-semibold shadow w-full rounded-xl p-4 md:p-3 border-none transition-all ease-in-out delay-1000`}
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;
const inactive = (props) => css`
	${tw`text-appTextDark! bg-transparent! text-xs md:text-base font-semibold  w-full rounded-xl p-4 md:p-3 border-none transition-all ease-in-out delay-1000`}
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;

const Guests = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	// const experience = Auth.getExperience();
	const couple = Auth.getCouple();
	const [wvalue, setValue] = useState("bride");
	const [selected, setSelected] = useState({});
	const [inviteVisible, setInviteVisible] = useState(false);

	const { data: invites, refetch, isLoading: inviteLoading } = useGuestList();

	const wedding_invites = invites?.data?.data?.wedding_invites;
	const totalInvites = invites?.data?.data?.total;

	const { mutateAsync: sendInvite, isLoading: inviteeloading } =
		useMutation(sendWeddingInvite);

	const handleSend = async () => {
		if (isEmpty(selected)) {
			return;
		}

		const data = {
			guestIds: [selected?.id],
		};

		try {
			const res = await sendInvite(data);
			console.log(res);
			const { hasError } = res.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: res.data.errors.message,
				});
			}
			Toast.fire({
				icon: "success",
				title: "Invite sent successfully",
			});
		} catch (error) {
			errorHandler(error);
		}
	};

	const { mutateAsync: delInvitee, isLoading: delloading } =
		useMutation(deleteWeddingInvite);

	const handleDelete = async () => {
		if (isEmpty(selected)) {
			return;
		}

		try {
			const response = await delInvitee(selected.id);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				console.log(response);
				const { title, message } = response.data.errors;
				Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${response.data.data}`,
				});
				setTimeout(() => {
					refetch();
				}, 500);
			}
		} catch (err) {
			return errorHandler(err);
		}
	};

	const MainSection = () => {
		return (
			<div tw="container">
				{inviteeloading && <PageLoading />}
				<div tw="w-full bg-gray-200 flex flex-row flex-nowrap gap-2 p-2 rounded-xl">
					<button
						value="bride"
						css={wvalue === "bride" ? active : inactive}
						onClick={(e) => {
							setValue(e.target.value);
						}}>
						Bride
					</button>
					<button
						value="groom"
						css={wvalue === "groom" ? active : inactive}
						onClick={(e) => {
							setValue(e.target.value);
						}}>
						Groom
					</button>
				</div>

				<div tw="w-full flex flex-row items-baseline flex-wrap justify-between mt-8">
					<div tw="flex flex-row items-center gap-4">
						<Image
							preview={false}
							src={wvalue === "bride" ? wife : hus}
							alt=""
							tw="h-10 w-10 rounded-full"
						/>
						<div>
							<h3 tw="p-0 m-0 font-bold">
								{wvalue === "bride"
									? `${couple?.bride_firstname} ${couple?.bride_lastname}`
									: `${couple?.groom_firstname} ${couple?.groom_lastname}`}
							</h3>
							<p tw="p-0 m-0 opacity-50 font-semibold capitalize">
								{wvalue}
							</p>
						</div>
					</div>

					<div tw="font-semibold opacity-50">
						{totalInvites} guests
					</div>
				</div>
				<div
					tw="overflow-y-scroll "
					css={hideScrollbar}
					style={{ height: "calc(100vh - 20rem)" }}>
					<div tw="bg-gray-50 flex flex-col gap-4 w-full mt-4 pb-4 rounded mb-12">
						{inviteLoading ? (
							<div tw="flex items-center justify-center p-4 ">
								<Loading tw="text-appPink" />
							</div>
						) : isEmpty(wedding_invites) ? (
							<EmptyData />
						) : (
							wedding_invites?.map((invitee, i) => {
								// console.log(invitee);
								return (
									<Fragment key={i}>
										{wvalue === invitee.section && (
											<div
												key={i}
												tw="bg-white w-full p-2 flex flex-row gap-2 flex-wrap items-center justify-between"
												css={{
													boxShadow:
														"0px 8px 30px rgba(80, 85, 136, 0.06)",
												}}
												onClick={() =>
													setSelected(invitee)
												}>
												<span tw="w-auto order-first sm:w-5/12 font-semibold p-2">
													{invitee.firstname}{" "}
													{invitee.lastname}{" "}
												</span>
												<span
													tw="order-2 md:order-2 px-3 py-2 text-center w-1/3  sm:w-2/12 rounded-3xl font-semibold text-xs capitalize"
													css={
														invitee.response ===
														"accepted"
															? {
																	background:
																		"rgba(33, 150, 84, 0.1)",
																	color: "#219653",
															  }
															: {
																	background:
																		"rgba(235, 87, 87, 0.1)",
																	color: "#EB5757",
															  }
													}>
													{invitee.response}
												</span>
												<Popconfirm
													placement="top"
													title={`${
														invitee.was_invited
															? "Resend"
															: "Send"
													} invitation to this guest?`}
													onConfirm={handleSend}
													okText="Send"
													cancelText="Cancel">
													<button tw="order-4 md:order-3 px-3 py-2 w-1/3 text-center  sm:w-2/12 border-none text-appTextDark text-sm bg-transparent font-semibold hover:(cursor-pointer opacity-60)">
														Send Iv
													</button>
												</Popconfirm>
												<Popconfirm
													placement="top"
													title={
														"Are you sure you wish to delete this invitee?"
													}
													onConfirm={handleDelete}
													okText="Yes"
													cancelText="No">
													<button tw="order-last md:order-4  px-3 py-2 w-1/3 text-center  sm:w-2/12 border-none text-appPink text-sm bg-transparent font-semibold">
														{delloading ? (
															<Loading tw="text-appPink" />
														) : (
															"Delete"
														)}
													</button>
												</Popconfirm>
												<span tw="order-3 md:order-last">
													{invitee.was_invited ? (
														<Tooltip
															title="Invite sent"
															color={"#219653"}>
															<ScheduleOutlined tw="px-3 py-2" />
														</Tooltip>
													) : (
														<Tooltip
															title="Yet to send invite"
															color={"#EB5757"}>
															<AlertOutlined tw="px-3 py-2" />
														</Tooltip>
													)}{" "}
												</span>
											</div>
										)}
									</Fragment>
								);
							})
						)}
					</div>
				</div>

				<Modal
					footer=""
					visible={inviteVisible}
					width={isMobile ? "100%" : "55%"}
					centered
					onCancel={() => setInviteVisible(false)}
					maskClosable={false}>
					<Invite refetch={refetch} hideOnMobile={false} />
				</Modal>
				{isMobile && (
					<button
						css={[floatBtn]}
						onClick={() => setInviteVisible(true)}>
						+
					</button>
				)}
			</div>
		);
	};

	return (
		<>
			<Wrapper>
				<SplitPane
					wrapDirection={"column"}
					left={<MainSection />}
					right={<Invite refetch={refetch} hideOnMobile={true} />}
				/>
			</Wrapper>
		</>
	);
};

export default Guests;
